import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FluentDialog2 } from '../../../../../../../components/FluentUI/Fluent-Dialog2';
import FluentUiIcon from '../../../../../../../assets/fluent-ui-icon';
import { FluentButton } from '../../../../../../../components/FluentUI/Fluent-Button';
import { FluentDropdown } from "../../../../../../../components/FluentUI/Fluent-Dropdown";
import { FluentDropdownOptionAsObject } from "../../../../../../../components/FluentUI/Fluent-Dropdown-Option-As-Object.jsx";

import { DEFAULT_THEN_EVENT_STATE, thenModalEventTypes, DEFAULT_DYNAMIC_FORM_AUTOMATION_THEN_AVAILABILITY, ValueType, isThenEventValid, isThenEventDuplicate } from './automation-helpers';
import SelectMemberProject from '../../../../../../../components/select-member/select-member-project.jsx';

const createAvailabilityData = (newData) => {
    let data = [];
    newData.forEach(element => {
        if (element.IsGroup) {
            data.push({
                ...DEFAULT_DYNAMIC_FORM_AUTOMATION_THEN_AVAILABILITY,
                GroupId: element.GroupId,
                GroupName: element.Name,
            });
            return;
        }
        else {
            data.push({
                ...DEFAULT_DYNAMIC_FORM_AUTOMATION_THEN_AVAILABILITY,
                UserId: element.UserId,
                UserName: element.Name,
            });
        }
    });
    return data;
};

const MemberSelector = ({ userSelection, onMembersChange }) => (
    <div className='mt-2'>
        <SelectMemberProject
            data={userSelection}
            saveMembers={(newMembers) => onMembersChange(createAvailabilityData(newMembers))}
            saveOwner={() => { }}
            selectedOwner={{ Id: null }}
            user={{ userID: null }}
            noOwnerDropDown={true}
            isEdit={false} />
    </div>
);

const FieldAvailabilityContent = ({ fieldsInputs, setEventData, userSelection, setAvailabilityData, eventData }) => (
    <>
        <div className='mt-2'>
            <FluentDropdownOptionAsObject
                options={fieldsInputs?.map((field) => ({
                    name: field.LocalLabel,
                    id: field.Id
                }))}
                onChange={(e, data) => {
                    const field = fieldsInputs.find(f => f.Id === data.optionValue);
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldId: field?.DynamicFieldId,
                        EventDynamicFieldName: field?.LocalLabel,
                        EventDynamicFormFieldId: field?.Id,
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldName}
                label="Field"
                labelStyle="font-weight-normal"
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                className='mt-2'
                label="Field Is Editable"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldEditable: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldEditable ? "True" : "False"}
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                label="Field Is Required"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldMandatory: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldMandatory ? "True" : "False"}
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                label="Field Is Visible"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldVisible: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldVisible ? "True" : "False"}
            />
        </div>
        <MemberSelector userSelection={userSelection} onMembersChange={setAvailabilityData} />
    </>
);

const FieldResetContent = ({ fieldsInputs, setEventData, eventData }) => (
    <>
        <div className='mt-2'>
            <FluentDropdownOptionAsObject
                options={fieldsInputs?.map((field) => ({
                    name: field.LocalLabel,
                    id: field.Id
                }))}
                onChange={(e, data) => {
                    const field = fieldsInputs.find(f => f.Id === data.optionValue);
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldId: field?.DynamicFieldId,
                        EventDynamicFieldName: field?.LocalLabel,
                        EventDynamicFormFieldId: field?.Id,
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldName}
                label="Field"
                labelStyle="font-weight-normal"
            />
        </div>
    </>
);

const FieldInsertContent = ({ fieldsInputs, setEventData, eventData }) => {
    const selectedField = fieldsInputs?.find(f =>
        eventData?.EventDynamicFormFieldId != null
            ? f.Id === eventData.EventDynamicFormFieldId
            : f.DynamicFieldId === eventData.EventDynamicFieldId
    );

    return (
        <>
            <div className='mt-2'>
                <FluentDropdownOptionAsObject
                    options={fieldsInputs?.map((field) => ({
                        name: field.LocalLabel,
                        id: field.Id
                    }))}
                    onChange={(e, data) => {
                        const field = fieldsInputs.find(f => f.Id === data.optionValue);
                        setEventData((prev) => ({
                            ...prev,
                            EventDynamicFieldId: field?.DynamicFieldId,
                            EventDynamicFieldName: field?.LocalLabel,
                            EventDynamicFormFieldId: field?.Id,
                            EventTypeValue: "",
                        }));
                    }}
                    defaultValue={eventData.EventDynamicFieldName}
                    label="Field"
                    labelStyle="font-weight-normal"
                />
            </div>
            {eventData?.EventDynamicFieldId != null && (
                <div className='mt-2'>
                    <ValueType selectedField={selectedField} eventData={eventData} setEventData={setEventData} />
                </div>
            )}
        </>
    );
};

const FormAvailabilityContent = ({ eventData, setEventData, userSelection, setAvailabilityData }) => {
    return (
        <>
            <div className='mt-2'>
                <FluentDropdown
                    label="Form Availability"
                    placeholder="Select a value"
                    options={["True", "False"]}
                    onChange={(e) => {
                        setEventData((prev) => ({
                            ...prev,
                            EventTypeValue: e.target.textContent || e.target.value,
                        }));
                    }}
                    defaultValue={eventData.EventTypeValue ?? "True"}
                />
            </div>
            <MemberSelector userSelection={userSelection} onMembersChange={setAvailabilityData} />
        </>
    );
};

const SectionAvailabilityContent = ({ currentForm, eventData, setEventData, userSelection, setAvailabilityData }) => (
    <>
        <div className='mt-2'>
            <FluentDropdownOptionAsObject
                options={currentForm?.SubForms?.map((field) => ({
                    name: field.Label,
                    id: field.Id
                }))}
                onChange={(e, data) => {
                    let subForm = currentForm?.SubForms?.find(f => f.Id === data.optionValue);
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicSectionId: subForm?.Id,
                        EventDynamicSectionName: subForm?.Label,
                    }));
                }}
                label="Sections"
                placeholder="Select a Section"
                labelStyle="font-weight-normal"
                defaultValue={eventData.EventDynamicSectionName}
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                className='mt-2'
                label="Fields Are Editable"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldEditable: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldEditable ? "True" : "False"}
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                label="Fields Are Required"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldMandatory: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldMandatory ? "True" : "False"}
            />
        </div>
        <div className='mt-2'>
            <FluentDropdown
                label="Fields Are Visible"
                placeholder="Select a value"
                options={["True", "False"]}
                onChange={(e) => {
                    setEventData((prev) => ({
                        ...prev,
                        EventDynamicFieldVisible: e.target.textContent == "True",
                    }));
                }}
                defaultValue={eventData.EventDynamicFieldVisible ? "True" : "False"}
            />
        </div>
        <MemberSelector userSelection={userSelection} onMembersChange={setAvailabilityData} />
    </>
);

const ChangeFormStatusContent = ({ formStatuses, eventData, setEventData }) => (
    <div className='mt-2'>
        <FluentDropdownOptionAsObject
            options={formStatuses?.map((status) => ({
                name: status.Name,
                id: status.Id
            }))}
            onChange={(e, data) => {
                setEventData((prev) => ({
                    ...prev,
                    EventTypeStatus: data.optionValue,
                    EventTypeStatusName: data.optionText,
                }));
            }}
            label="Form Status"
            labelStyle="font-weight-normal"
            defaultValue={eventData.EventTypeStatusName}
        />
    </div>
);

export const ThenModal = ({ isOpen, onClose, onSave, formStatuses, fieldsInputs, currentForm, allUsers, isChained, selectedThenEvent, selectedThenAvailability, existingThenEvents, editingIndex }) => {
    const [eventData, setEventData] = useState({
        ...selectedThenEvent,
        RelatedToCondition: isChained ? "AND" : null
    });
    const [availabilityData, setAvailabilityData] = useState(selectedThenAvailability || [DEFAULT_DYNAMIC_FORM_AUTOMATION_THEN_AVAILABILITY]);
    let selectedMembers = allUsers.allUsers?.filter(user =>
        availabilityData.some(availability =>
            (availability.GroupId && availability.GroupId === user.GroupId) ||
            (availability.UserId && availability.UserId === user.UserId)
        )
    );
    const userSelection = {
        ...allUsers,
        Members: selectedMembers || []
    };
    const eventTypeContent = {
        "Field Availability": <FieldAvailabilityContent fieldsInputs={fieldsInputs} eventData={eventData} setEventData={setEventData} userSelection={userSelection} setAvailabilityData={setAvailabilityData} />,
        "Field Reset": <FieldResetContent fieldsInputs={fieldsInputs} eventData={eventData} setEventData={setEventData} />,
        "Field Insert": <FieldInsertContent fieldsInputs={fieldsInputs} eventData={eventData} setEventData={setEventData} />,
        "Form Availability": <FormAvailabilityContent eventData={eventData} setEventData={setEventData} userSelection={userSelection} setAvailabilityData={setAvailabilityData} />,
        "Section Availability": <SectionAvailabilityContent currentForm={currentForm} eventData={eventData} setEventData={setEventData} userSelection={userSelection} setAvailabilityData={setAvailabilityData} />,
        "Change Form Status To": <ChangeFormStatusContent formStatuses={formStatuses} eventData={eventData} setEventData={setEventData} />,
        "Reset to Status": <ChangeFormStatusContent formStatuses={formStatuses} eventData={eventData} setEventData={setEventData} />
    };

    return (
        <FluentDialog2 open={isOpen}>
            <div className="task-type-dialog-title">
                <p>New Then Event</p>
                <p onClick={onClose}>
                    <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
                </p>
            </div>
            <div className="task-type-dialog-content">
                {isChained &&
                    <FluentDropdown
                        label="Selector Type"
                        placeholder="AND/OR"
                        options={["AND", "OR"]}
                        defaultValue={eventData.RelatedToCondition}
                        onChange={(e) => {
                            setEventData((prev) => ({
                                ...prev,
                                RelatedToCondition: e.target.textContent || e.target.value,
                            }));
                        }}
                    />
                }
                <div className="task-type-create-edit-field-dialog mt-2">
                    <FluentDropdown
                        label="Select an Event Type"
                        placeholder="Select an Event Type"
                        options={thenModalEventTypes}
                        defaultValue={eventData.EventType}
                        onChange={(e) => {
                            setEventData((prev) => ({
                                ...DEFAULT_THEN_EVENT_STATE,
                                EventType: e.target.textContent || e.target.value,
                                RelatedToCondition: prev.RelatedToCondition,
                                ...(e.target.textContent || e.target.value === "Form Availability" ? { EventTypeValue: "True" } : {})
                            }));
                            setAvailabilityData([]);
                        }}
                    />
                    {eventTypeContent[eventData.EventType]}
                    {isThenEventDuplicate(eventData, existingThenEvents, editingIndex, fieldsInputs) && (
                        <div className="text-danger small mt-2" style={{ whiteSpace: "nowrap", textAlign: "center" }}>This event already exists in this automation.</div>
                    )}
                </div>
            </div>
            <div className="task-type-dialog-footer">
                <FluentButton
                    onClick={onClose}
                    text={"Cancel"}
                    backgroundColor={"#0F6CBD"}
                />
                <FluentButton
                    onClick={() => onSave(eventData, availabilityData)}
                    appearance="primary"
                    text="Save Event"
                    backgroundColor={"#0F6CBD"}
                    disabled={!isThenEventValid(eventData, availabilityData, isChained) || isThenEventDuplicate(eventData, existingThenEvents, editingIndex, fieldsInputs)}
                />
            </div>
        </FluentDialog2>
    );
};

ThenModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    formStatuses: PropTypes.array,
    fieldsInputs: PropTypes.array,
    currentForm: PropTypes.object,
    allUsers: PropTypes.shape({
        allUsers: PropTypes.array,
        Members: PropTypes.array,
    }),
    isChained: PropTypes.bool,
    selectedThenEvent: PropTypes.object,
    selectedThenAvailability: PropTypes.array,
    existingThenEvents: PropTypes.array,
    editingIndex: PropTypes.number,
};

export default ThenModal;
